//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import IconView from "./IconView.vue";

export default {
  name: "CarouselCategories",
  components: { IconView },
  data() {
    return {
      navTreeItems: [],
      colors: [
        '#FB8B24',
        '#41B06E',
        '#7C73C0',
        '#D04848',
        '#7A4495',
        '#CD5888',
        '#325288',
        '#59C1BD'
      ],
    }
  },
  computed: {
    navTreeDetail() {
      var categories = null

      var responce = this.$store.getters['categories/navTreeDetail'];

      if(responce){
        categories = []
        /*
        categories.push({
          id: 0,
          url: { name: 'art' },
          icon: {
            path: null,
            icon: "64ff2078a5eba16942615845",
            path_valid: false
          },
          label: "Интересное",
          stat: null
        });*/

        var indexCat = null;
        var category = null;

        var respCat = responce.map(x => {
          const res = { ...x }
          delete res.items
          return res.node
        })

        for(indexCat in respCat){
          category = respCat[indexCat]

          categories.push({
            id: category.id,
            objects_url: `/s/${category.url}`,
            art_url: `/art?category=${category.url}`,
            icon: {
              path: `/public/object_categories_files/${category.id}/`,
              icon: category.icon,
              path_valid: !category.icon
            },
            label: category.label,
            stat:{
              objects_total: category.objects_total,
              materials_total: category.materials_total,
            }
          })
        }
      }

      return categories
    },
  },
  watch: {
    navTreeDetail(newVal) {
      this.navTreeItems = newVal;
    }
  },
  async created() {
    await this.$store.dispatch('categories/getNavTreeDetail');
  },
  mounted(){
    this.navTreeItems = this.navTreeDetail;
  },
  methods:{
    getColor(index) {
      let color = this.colors[index % this.colors.length];

      return {
        backgroundColor: color
      };
    },
  }
}
